import React from "react";

export function DomainNameCardInput({ label, value, onChange, valid, type, onFocus, required = false }) {
    const fieldId = `oct-settings-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

    return (
        <div className="form-group oct_settings-modal-field">
            <div className="oct_settings-modal-form-group">
                <label htmlFor={fieldId} className="oct_settings-modal-label">
                    {label}
                    {required && <span className="modal-v2-required-mark">*</span>}
                </label>
                <input type={type || 'text'}
                    id={fieldId}
                    className={`form-control oct_settings-modal-input ${valid ? '' : 'border-danger'}`}
                    value={value}
                    onChange={event => onChange(event.target.value)}
                    onFocus={onFocus} />
            </div>
        </div>
    )
}
